// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bb1f272f","455":"d5bce961","501":"2bf61511","977":"173678e6"}[chunkId] + ".chunk.js";
};